"use client";

import AnimatedBackground from "@/components/core/animate-background";
import { useCarousel } from "@/components/ui/carousel";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";

export function Categories({ data }: { data: string[] }) {
  const { api: emblaApi } = useCarousel();

  const [activeIndex, setActiveIndex] = useState(0);

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaApi) return;

      setActiveIndex(index);
      emblaApi.scrollTo(index);
    },
    [emblaApi],
  );

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    const i = emblaApi.selectedScrollSnap();

    setActiveIndex(i);
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();

    emblaApi.on("select", onSelect).on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className="absolute inset-x-0 top-10 z-50 mx-auto max-w-[1000px] flex-col gap-8 px-4 lg:flex lg:px-0">
      <div className="flex w-full flex-col">
        <div className="mx-auto flex w-full items-center justify-between gap-4">
          <AnimatedBackground
            defaultValue={activeIndex}
            onValueChange={(value) => {
              onThumbClick(Number(value));
            }}
            className="border-b"
            transition={{
              ease: "easeInOut",
              duration: 0.2,
            }}
          >
            {data.map((x, i) => (
              <button
                key={i}
                data-id={i}
                type="button"
                className={cn(
                  "pb-4 text-center text-sm text-secondary lg:text-[20px] ltr:font-playfair",
                  activeIndex === i ? "text-secondary" : "text-secondary/50",
                )}
              >
                {x}
              </button>
            ))}
          </AnimatedBackground>
        </div>
        <Separator className="bg-secondary/20" />
      </div>
    </div>
  );
}
